import { fetchProjectAnalysisReportHtml } from './fetchProjectAnalysisReportHtml';

function safeDownloadFilename(name: string): string {
  const trimmed = name.trim();
  if (!trimmed) return 'report.html';
  if (/\.html?$/i.test(trimmed)) return trimmed;
  return `${trimmed}.html`;
}

export async function downloadProjectAnalysisReportHtmlFile(
  reportId: string,
  token: string | null | undefined,
  suggestedFilename: string,
): Promise<void> {
  const result = await fetchProjectAnalysisReportHtml(reportId, token);
  if (!result.ok) {
    throw new Error('Could not download HTML');
  }
  const blob = new Blob([result.html], { type: 'text/html;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = safeDownloadFilename(suggestedFilename);
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
